import { useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as HelmetSvg } from '../../assets/helmet.svg'
import '../Motorcycle/MotorcycleBlockView.scss'
const classnames = require('classnames')

export const OperatorBlockView = ({ firstName, lastName }) => {
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))

  return (
    <>
      <FlexView>
        {firstName && (
          <>
            <HelmetSvg className="large-icon margin-left-small" />
            <FlexView vAlignContent={'center'} className="m-details-block">
              <div
                className={classnames('text-body black', { 'text-overflow-elipsis-tiny': isMobile, 'text-overflow-elipsis': !isMobile })}
              >
                {firstName} {lastName}
              </div>
            </FlexView>
          </>
        )}
      </FlexView>
    </>
  )
}
